import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
	static targets = ["list", "row", "number", "file", "bar", "count"];

	declare readonly listTarget: HTMLElement;
	declare readonly rowTargets: HTMLElement[];
	declare readonly numberTargets: HTMLElement[];
	declare readonly fileTargets: HTMLElement[];
	declare readonly barTarget: HTMLElement;
	declare readonly countTarget: HTMLElement;

	up(event: Event) {
		this.move(event, -1);
	}

	down(event: Event) {
		this.move(event, 1);
	}

	reset() {
		const original = [...this.rowTargets].sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index));
		this.listTarget.append(...original);
		this.renumber();
	}

	// A pending order previews the 0..n-1 numbers a save would store; back in the
	// original order, the stored positions (which may have gaps) come back.
	renumber() {
		const pending = this.rowTargets.some((row, index) => Number(row.dataset.index) !== index);
		let moved = 0;
		this.rowTargets.forEach((row, index) => {
			const changed = pending && Number(row.dataset.position) !== index;
			if (changed) moved += 1;
			row.classList.toggle("odo-row-highlight", changed);
			this.numberTargets[index].textContent = pending ? String(index) : (row.dataset.position ?? "");
			this.fileTargets[index].textContent = pending ? `${String(index).padStart(2, "0")}-${row.dataset.slug}.md` : (row.dataset.file ?? "");
		});
		this.countTarget.textContent = String(moved);
		this.barTarget.classList.toggle("hidden", !pending);
		this.barTarget.classList.toggle("flex", pending);
	}

	private move(event: Event, step: -1 | 1) {
		const button = event.currentTarget as HTMLElement;
		const row = button.closest("tr");
		const neighbour = step < 0 ? row?.previousElementSibling : row?.nextElementSibling;
		if (!row || !neighbour) return;

		if (step < 0) neighbour.before(row);
		else neighbour.after(row);
		this.renumber();
		button.focus();
	}
}
